<template lang="pug">
.content-center
  .overlay
  .swiper-container.lobby-swiper(v-if="!whiteLabel")
    template(v-if="language == 'cn'")
      iframe(src='https://banner.wbmarketingtools.com/event-banner/cn/' allowtransparency='true')
    template(v-else)
      iframe(src='https://banner.wbmarketingtools.com/event-banner/en/' allowtransparency='true')
    img.img-fluid(src='images/transparent-slider-height.png')
  Marquee
  .section-sport
    .lobby-title
      ThemeImage.icon(src='images/light/sport/blue/1.svg')
      | {{ $t("ui.sports") }}
    template(v-if="!whiteLabel")
      .swiper.sportSwiper
        .swiper-wrapper
          .swiper-slide.thumbnail(v-if="showWorldCupEvent")
            .sport-thumb(@click='setMenu0("event", "3", getEventDate(worldcupEventStart))')
              img(src='images/worldcup-landing.gif' :alt="$t('ui.worldcup')")
            span.name {{ $t("ui.worldcup") }}
          .swiper-slide.thumbnail(
            v-for="sport in sportItems"
            :key="`sport-${sport.id}`"
          )
            .sport-thumb(@click="sport.onClick")
              img(
                :src='getImgUrl(sport.image)'
                :alt="sport.caption"
                loading="lazy"
              )
            //- span.name {{ sport.caption }}
  .section-live
    .lobby-title
      ThemeImage.icon(src='images/light/live.svg')
      | {{ $t("ui.live_now") }}
    .live-wrapper
      iframe.live-iframe(
        :src="widgetUrls.livestream"
        allowtransparency="true"
        frameborder="0"
        :title="$t('ui.live_streaming')"
      )
  .section-upcoming
    .lobby-title
      ThemeImage.icon(src='images/light/sport/blue/1.svg')
      | {{ $t("ui.upcoming_matches") }}
    .upcoming-wrapper
      iframe.upcoming-iframe(
        :src="widgetUrls.upcoming"
        allowtransparency="true"
        frameborder="0"
        :title="$t('ui.upcoming')"
      )
  .secton-others
    .lobby-title
      ThemeImage.icon(src='images/light/live.svg')
      | {{ $t("ui.others_game") }}
    .game-container
      ul.filter-list
        li.filter(
          v-for="filter in gameFilters"
          :key="filter.key"
          :data-filter="filter.filter"
          :class="{ 'mixitup-control-active': activeFilter === filter.key }"
          @click="setActiveFilter(filter.key)"
        )
          img.inactive(:src="filter.inactiveImg")
          img.active(:src="filter.activeImg")
          span {{ $t(filter.textKey) }}
      .filter-content
        .game-empty(v-if="isActiveFilterEmpty")
          img.no-info(src='images/empty-icon.png' alt='')
          p.no-message.text-center {{ $t("message.no_games_available") }}
        .game-wrapper(v-show="!isActiveFilterEmpty")
          .item.mix.filter-casino(
            v-for="suite in casinoSuites"
            :key="`casino-game-${suite.id}`"
            v-if="suite.shouldShow"
          )
            router-link(
              :to="`/casino?suite=${suite.id}`"
              target="_blank"
              @click="openCasinoWindow($event)"
            )
              img(:src='getImgUrl(suite.image)')
          .item.mix.filter-slot(
            v-for="slot in slotItems"
            :key="`slot-game-${slot.mode}`"
          )
            router-link(
              v-if="hasSlotGameList(slot)"
              :to="`/slotsMain?mode=${slot.mode}`"
            )
              img(:src='getImgUrl(slot.image)')
            router-link(
              v-else
              :to="`/slots?mode=${slot.mode}`"
              target="_blank"
              @click.native.prevent="openSlotWindow($event, slot)"
            )
              img(:src='getImgUrl(slot.image)')
          .item.mix.filter-poker(
            v-for="poker in pokerItems"
            :key="`poker-game-${poker.mode}`"
          )
            router-link(
              :to="`/slots?mode=${poker.mode}`"
              target="_blank"
              @click.native.prevent="openSlotWindow($event, poker)"
            )
              img(:src='getImgUrl(poker.image)')

</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import { getTheme, themedImage } from "@/utils/theme.js";
import toolBar from "@/components/mobile/toolBar";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import xhr from "@/library/_xhr-game.js";
import mixinMain from "@/library/mixinMain";
import mixinProvider from "@/library/mixinProvider";

export default {
  components: {
    toolBar,
    Marquee
  },
  mixins: [mixinMain, mixinProvider],
  data() {
    return {
      // WORLD CUP flag — index 2, same as sidebar SPECIAL_EVENTS
      // SPECIAL_EVENTS: [0, 0, 0, 0, 0, 0, 0, 0],
      worldcupEventStart: "2026-06-11T12:00:00",
      worldcupEventEnd: "2026-07-19",
      sportSwiper: null,
      pokerSwiper: null,
      gamelist: [],
      activeFilter: 'slot',
      mixer: null,
      themeObserver: null,
      currentTheme: getTheme()
    };
  },
  computed: {
    SPECIAL_EVENTS() {
      return [0, 0, this.wcMode ? 1 : 0, 0, 0, 0, 0, 0];
    },
    wcMode() {
      return config.wcMode;
    },
    debugMode() {
      return config.debugMode;
    },
    sportsName() {
      return this.$store.state.layout.sports;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    language() {
      return this.$store.getters.language;
    },
    currencyCode() {
      return this.$store.getters.currencyCode;
    },
    showWorldCupEvent() {
      if (!this.SPECIAL_EVENTS[2]) {
        return false;
      }
      const today = this.$dayjs().startOf("day");
      const eventEnd = this.$dayjs(this.worldcupEventEnd).endOf("day");
      return today.valueOf() <= eventEnd.valueOf();
    },
    widgetUrls() {
      const baseUrl = config.widgetUrl;
      const themeParam = this.currentTheme === 'dark' ? 8 : 1;
      const params = `theme=${themeParam}&lang=${this.language}`;
      
      return {
        upcoming: `${baseUrl}/hotmatch?${params}`,
        livestream: `${baseUrl}/livestream?${params}`
      };
    },
    gameFilters() {
      const theme = this.currentTheme;
      return [
        {
          key: 'slot',
          filter: '.filter-slot',
          inactiveImg: themedImage('images/light/game-type/slot.svg', theme),
          activeImg: themedImage('images/light/game-type/slot-active.svg', theme),
          textKey: 'ui.slots'
        },
        {
          key: 'casino',
          filter: '.filter-casino',
          inactiveImg: themedImage('images/light/game-type/casino.svg', theme),
          activeImg: themedImage('images/light/game-type/casino-active.svg', theme),
          textKey: 'ui.casino'
        },
        {
          key: 'poker',
          filter: '.filter-poker',
          inactiveImg: themedImage('images/light/game-type/poker.svg', theme),
          activeImg: themedImage('images/light/game-type/poker-active.svg', theme),
          textKey: 'ui.poker'
        }
      ];
    },
    sportItems() {
      const items = [];
      
      // Cricket - only for BDT currency
      if (this.currencyCode === 'BDT') {
        items.push({
          id: 12,
          image: 'sport/cricket.png?v=12',
          caption: this.sportsName[12],
          onClick: () => this.setMenu2x(12)
        });
      }
      
      // Soccer
      items.push({
        id: 1,
        image: 'sport/soccer.png?v=12',
        caption: this.sportsName[1],
        onClick: () => this.setMenu2x(1)
      });
      
      // Virtual Games
      items.push({
        id: 56,
        image: 'sport/v-game.png?v=12',
        caption: this.$t('ui.egames'),
        onClick: () => this.setMenu2x(57)
      });
      
      // Basketball
      items.push({
        id: 2,
        image: 'sport/basketball.png?v=12',
        caption: this.sportsName[2],
        onClick: () => this.setMenu2x(2)
      });
      
      // Esports - conditional
      if (!this.whiteLabel && this.esports2) {
        items.push({
          id: 20,
          image: 'sport/esports.png?v=12',
          caption: this.sportsName[20],
          onClick: () => {
            window.open('/slots?mode=3', '_blank', 'status=no,toolbar=no,menubar=no,location=no');
          }
        });
      }
      
      // Tennis
      items.push({
        id: 7,
        image: 'sport/tennis.png?v=12',
        caption: this.sportsName[7],
        onClick: () => this.setMenu2x(7)
      });
      
      // Table Tennis
      items.push({
        id: 4,
        image: 'sport/table-tennis.png?v=12',
        caption: this.sportsName[4],
        onClick: () => this.setMenu2x(4)
      });
      
      // Ice Hockey
      items.push({
        id: 9,
        image: 'sport/ice-hockey.png?v=12',
        caption: this.sportsName[9],
        onClick: () => this.setMenu2x(9)
      });
      
      // Volleyball
      items.push({
        id: 11,
        image: 'sport/volleyball.png?v=12',
        caption: this.sportsName[11],
        onClick: () => this.setMenu2x(11)
      });
      
      return items;
    },
    pokerItems() {
      const CURRENCY_POKER = ['CNY', 'IDR', 'MMK', 'MMO', 'MYR', 'SGD', 'THB', 'USD'];
      const CURRENCY_POKER_DB = ['MYR'];
      
      const isCurrencyInList = (currencyList) => currencyList.includes(this.currencyCode);
      
      return [
        {
          mode: 10,
          image: 'poker/lobby_thumb-dbpoker.jpg?v=12',
          textKey: 'ui.poker_db',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_POKER_DB)
        },
        {
          mode: 14,
          image: 'lobby_thumb-binary.jpg?v=12',
          textKey: 'ui.binary_allin',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_POKER) && false
          //hide binary allin for now
        }
      ].filter(poker => poker.shouldShow);
    },
    isActiveFilterEmpty() {
      switch (this.activeFilter) {
        case 'slot':
          return this.slotItems.length === 0;
        case 'casino':
          return this.casinoSuites.filter(suite => suite.shouldShow).length === 0;
        case 'poker':
          return this.pokerItems.length === 0;
        default:
          return true;
      }
    }
  },
  watch: {
    sportItems: {
      handler(newVal) {
        this.$nextTick(() => {
          if (this.sportSwiper) {
            this.sportSwiper.update();
          } else if ((newVal && newVal.length > 0) || this.showWorldCupEvent) {
            this.initializeSwiper();
          }
        });
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // this.launchJILIGameList(true);
  },
  mounted() {
    this.initializeSwiper();
    this.ensureMixitupInitialized();
    this.setupThemeObserver();
  },
  beforeDestroy() {
    if (this.sportSwiper) {
      this.sportSwiper.destroy(true, true);
      this.sportSwiper = null;
    }
    if (this.pokerSwiper) {
      this.pokerSwiper.destroy(true, true);
      this.pokerSwiper = null;
    }
    if (this.themeObserver) {
      this.themeObserver.disconnect();
      this.themeObserver = null;
    }
    if (this.mixer && typeof this.mixer.destroy === 'function') {
      this.mixer.destroy();
      this.mixer = null;
    }
  },
  methods: {
    initializeSwiper() {
      const slideCount = this.sportItems.length + (this.showWorldCupEvent ? 1 : 0);
      if (this.sportSwiper || slideCount === 0) {
        return;
      }
      
      this.$nextTick(() => {
        const swiperEl = this.$el.querySelector('.sportSwiper');
        if (!swiperEl || this.sportSwiper) {
          return;
        }
        
        try {
          this.sportSwiper = new Swiper('.sportSwiper', {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: false,
            loop: slideCount > 1,
            speed: 500,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            pagination: {
              el: '.swiper-pagination-thumb',
              clickable: true,
              dynamicBullets: true
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            breakpoints: {
              380: {
                slidesPerView: 3.5
              },
              768: {
                slidesPerView: 4.5
              },
              960: {
                slidesPerView: 5.5
              }
            },
            on: {
              init: function() {
                if (this.sportSwiper) {
                  this.sportSwiper.update();
                }
              }.bind(this)
            }
          });
        } catch (error) {
          console.error('Error initializing sport swiper:', error);
        }
      });
    },
    getImgUrl(e) {
      return config.resourceImgUrl + '/mobile/lobby-thumb/new/' + e;
    },
    openCasinoWindow(event) {
      event.preventDefault();
      const href = event.currentTarget.href;
      window.open(href, '_blank', 'status=no,toolbar=no,menubar=no,location=no');
      return false;
    },
    hasSlotGameList(slot) {
      const DIRECT_LAUNCH_CODES = new Set(['PGS', 'SP', 'NEXT', 'DB', 'WOW']);
      const PROVIDER_BEHAVIORS = {
        EPW: { listMethod: 'getEpwGameList' },
        WF: { listMethod: 'getWfGameList' },
        OSG: { listMethod: 'getLive22GameList' },
        PP: { listMethod: 'getPragmaticGameList' },
        JK: { listMethod: 'getJokerGameList' },
        JILI: { listMethod: 'getJiliGameList' },
        UU: { listMethod: 'getUuslGameList' }
      };
      
      const providerCode = slot.code;
      return providerCode && PROVIDER_BEHAVIORS[providerCode] && !DIRECT_LAUNCH_CODES.has(providerCode);
    },
    openSlotWindow(event, slot) {
      event.preventDefault();
      const href = `/slots?mode=${slot.mode}`;
      window.open(href, '_blank', 'status=no,toolbar=no,menubar=no,location=no');
      return false;
    },
    setupThemeObserver() {
      // Watch for theme changes and re-initialize mixitup if needed
      const html = document.documentElement;
      this.currentTheme = html.getAttribute('data-theme') || 'light';
      
      this.themeObserver = new MutationObserver(() => {
        const newTheme = html.getAttribute('data-theme') || 'light';
        // Only re-initialize if theme actually changed
        if (this.currentTheme !== newTheme) {
          this.$set(this, 'currentTheme', newTheme);
          // Re-initialize mixitup after theme change to ensure it works correctly
          this.$nextTick(() => {
            // Reset mixer so it gets re-initialized
            this.mixer = null;
            this.ensureMixitupInitialized();
          });
        }
      });
      this.themeObserver.observe(html, {
        attributes: true,
        attributeFilter: ['data-theme']
      });
    },
    ensureMixitupInitialized() {
      // Wait for DOM to be ready, then ensure mixitup is initialized
      this.$nextTick(() => {
        if (typeof mixitup === 'undefined') {
          console.warn('Mixitup library not loaded');
          return;
        }

        if (!this.$el) {
          return;
        }
        const container = this.$el.querySelector('.game-wrapper');
        if (!container) {
          return;
        }

        // Check if mixer already exists and is valid
        if (this.mixer && typeof this.mixer.filter === 'function') {
          // Mixer exists, just apply current filter
          const activeFilterConfig = this.gameFilters.find(f => f.key === this.activeFilter);
          if (activeFilterConfig) {
            this.mixer.filter(activeFilterConfig.filter);
          }
          return;
        }

        // Try to get existing mixer using getMixer if available
        let mixer = null;
        if (typeof mixitup.getMixer === 'function') {
          try {
            mixer = mixitup.getMixer('.game-wrapper');
          } catch (e) {
            console.warn('Error getting mixer:', e);
          }
        }

        // Initialize new mixer if it doesn't exist
        if (!mixer) {
          try {
            mixer = mixitup('.game-wrapper', {
              selectors: {
                target: '.mix'
              },
              animation: {
                duration: 0,
                effects: 'none'
              },
              load: {
                filter: '.filter-slot'
              }
            });
          } catch (e) {
            console.error('Error initializing mixitup:', e);
            return;
          }
        }

        // Store mixer instance
        this.mixer = mixer;
        
        // Apply initial filter
        if (this.mixer && this.activeFilter) {
          const activeFilterConfig = this.gameFilters.find(f => f.key === this.activeFilter);
          if (activeFilterConfig && typeof this.mixer.filter === 'function') {
            this.mixer.filter(activeFilterConfig.filter);
          }
        }
      });
    },
    setActiveFilter(filterKey) {
      this.activeFilter = filterKey;
      
      // Get the mixitup mixer instance and apply the filter
      this.$nextTick(() => {
        // Use stored mixer instance if available
        if (this.mixer && typeof this.mixer.filter === 'function') {
          const activeFilterConfig = this.gameFilters.find(f => f.key === filterKey);
          if (activeFilterConfig) {
            this.mixer.filter(activeFilterConfig.filter);
          }
          return;
        }

        // Try to get mixer if not stored
        if (typeof mixitup !== 'undefined') {
          let mixer = null;
          
          // Try getMixer if available
          if (typeof mixitup.getMixer === 'function') {
            try {
              mixer = mixitup.getMixer('.game-wrapper');
            } catch (e) {
              console.warn('Error getting mixer:', e);
            }
          }

          if (mixer && typeof mixer.filter === 'function') {
            this.mixer = mixer;
            const activeFilterConfig = this.gameFilters.find(f => f.key === filterKey);
            if (activeFilterConfig) {
              mixer.filter(activeFilterConfig.filter);
            }
          } else {
            // Re-initialize if mixer doesn't exist
            this.ensureMixitupInitialized();
          }
        }
      });
    },
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    setMenu2x(mode) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = ![1].includes(mode) ? "all" : "live";
      mi5["menu1"] = ![1].includes(mode) ? "today" : "live";
      // mi5["menu0"] = "all";
      // mi5["menu1"] = "today";
      mi5["menu2"] = parseInt(mode);
      mi5["menu3"] = "hdpou";
      config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);

      var options = {};
      options[mi5["menu2"]] = true;
      this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      this.$store.dispatch("layout/setMenuItems", mi5);
      // Prematch loads markets on mount. Emitting INVALIDATE here starts the
      // request on the lobby instance and blocks Sports from fetching live data.
      this.$router.push("/prematch");
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    /** Same navigation as sidebar World Cup tournament link */
    setMenu0(e, menuY, m, bt) {
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      mi5["menuX"] = false;
      if (EventBus.cancelParlay) EventBus.cancelParlay();
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
      $(".btn-parlay").removeClass("active");
      $(".btn-mmo-parlay").removeClass("active");

      mi5["menuY"] = menuY ? menuY.toString() : "0";
      mi5["menu2"] = this.menu2;

      switch (e) {
        case "event":
          mi5["menu0"] = "event";
          mi5["menu1"] = m == null ? "today" : m;
          mi5["menu3"] = bt == null ? "hdpou" : bt;
          if (config.vg1.includes(parseInt(mi5["menu2"], 10))) {
            mi5["menu2"] = 1;
          }
          break;
        default:
          return;
      }

      var changed = false;
      if (mi5["menuX"] != this.menuX) changed = true;
      if (mi5["menuY"] != this.menuY) changed = true;
      if (mi5["menu0"] != this.menu0) changed = true;
      if (mi5["menu1"] != this.menu1) changed = true;
      if (mi5["menu2"] != this.menu2) changed = true;
      if (mi5["menu3"] != this.menu3) changed = true;

      if (changed) {
        this.setDays(parseInt(mi5["menu2"], 10), mi5["menu1"]);
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }

      if (this.$route.path !== "/prematch") {
        this.$router.push("/prematch").catch(() => {});
      }
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
    // launchJILIGameList(mode) {
    //   var mobile = false;
    //   if (mode) {
    //     mobile = mode;
    //   }
    //   var args = {
    //     username: this.$store.getters.accountId,
    //     sessionid: this.$store.getters.sessionToken
    //   };

    //   xhr.launchJILIGameList(args).then(
    //     res => {
    //       // this.loading = false;
    //       if (res) {
    //         if (res.success == true) {
    //           this.url = res.data;
    //           if (res.data.length > 0) {
    //             // this.gamelist = res.data;
    //             const filteredList = res.data.filter(obj => obj.GameCategoryId === 5);
    //             this.gamelist = filteredList;
    //             // console.log(this.gamelist);
    //           } else {
    //             switch (res.status) {
    //               case "lotteryDisabled":
    //               case "currencyNotSupported":
    //               case "liveCasinoDisabled":
    //               case "EsportsDisabled":
    //               case "MiniGameDisabled":
    //                 this.error = this.$t("error." + res.status);
    //                 break;
    //               case "account_status_suspend":
    //                 this.error = this.$t("error.SUSPEND");
    //                 break;
    //               default:
    //                 this.error = this.$t("error.game_maintenance");
    //                 break;
    //             }
    //           }
    //         } else {
    //           switch (res.status) {
    //             case "lotteryDisabled":
    //             case "currencyNotSupported":
    //             case "liveCasinoDisabled":
    //             case "EsportsDisabled":
    //             case "MiniGameDisabled":
    //               this.error = this.$t("error." + res.status);
    //               break;
    //             case "account_status_suspend":
    //               this.error = this.$t("error.SUSPEND");
    //               break;
    //             default:
    //               this.error = this.$t("error.game_maintenance");
    //               break;
    //           }
    //         }
    //       }
    //     },
    //     err => {
    //       // this.loading = false;
    //       switch (err.status) {
    //         case "lotteryDisabled":
    //         case "currencyNotSupported":
    //         case "liveCasinoDisabled":
    //         case "EsportsDisabled":
    //         case "MiniGameDisabled":
    //           this.error = this.$t("error." + err.status);
    //           break;
    //         case "account_status_suspend":
    //           this.error = this.$t("error.SUSPEND");
    //           break;
    //         default:
    //           this.error = this.$t("error.game_maintenance");
    //           break;
    //       }
    //     }
    //   );
    // }
  }
};
</script>
